import { render } from "./ValueMetric.vue?vue&type=template&id=34a108c8"
import script from "./ValueMetric.vue?vue&type=script&lang=js"
export * from "./ValueMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValueMetric.vue"]])

export default __exports__